import FirebaseProvider from './firebase/Provider'
import MenuProvider from './menu/MenuProvider'
import CallProvider from './call/CallProvider'

const AppProvider = ({ children }) => {
  return (
    <FirebaseProvider>
      <CallProvider>
        <MenuProvider>
          {children}
        </MenuProvider>
      </CallProvider>
    </FirebaseProvider>
  )
}

export default AppProvider